import React, { useEffect, useState } from 'react';
const CHECKOUT_URL = 'https://diccionario-apple.impultienda.ar/checkout';
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink-900/95 px-4 py-3 backdrop-blur transition-transform duration-200 ease-out lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-263" data-mp="3lekxy0mh8evg">
      <div className="flex items-center justify-between gap-4" data-id="element-264" data-mp="3vc921h5z2yqa">
        <div data-id="element-265" data-mp="3qgk0j8ae77rc">
          <p className="text-sm font-extrabold tracking-tight text-white" data-id="element-266" data-mp="3qg1wvqlehr9e">
            $33.999 ARS
          </p>
          <p className="text-[11px] text-white/45" data-id="element-267" data-mp="212eya1l7n9ws">Libro + 5 bonos</p>
        </div>
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="rounded-full bg-accent px-5 py-3 text-xs font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-accent-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft" data-id="element-268" data-mp="1w2sndysuu5r5">
          Ir al pago seguro
        </a>
      </div>
    </div>;
}